// How many points a sale earns.
//
//   NT$100 spent -> 1 point, rounded down
//
// The base is `amount`, WHICH IS ALREADY NET of the whole-order discount and of
// anything redeemed against this same sale -- the cashier page computes it that
// way so the 統一發票 declares what was paid. You do not earn points on the part
// you paid for with points, and nothing here has to arrange that.
//
//   total 1000, redeeming 10 points and 50 credits -> amount 940
//   -> floor(940 / 100) = 9 points
//
// This used to do the subtraction itself, from the redemption values, and the
// arithmetic drifted out of step with them twice. Reading one number that is
// already correct is the fix for that whole class of bug.
//
// A RETURN SUGGESTS NOTHING. A corrective order's total is negative, so the
// answer is 0. The figure that belongs there is the staff's to type, and it is
// not a clawback of the earn alone: the return also owes back whatever was
// redeemed against the original order, so the net can land either side of zero.
// An order that spent 100 points and earned 30 comes back as 贈送點數 +70.
//
// This is a suggestion, not a rule the server enforces. The staff can type
// anything over the top of it, because campaigns change the rate more often
// than anyone wants to ship a deploy. The only ceiling is Shopline's own
// +/-999999, checked when the request body is built.

// ANSWERED, 2026-08-22: redemption DOES reduce the 統一發票 total. It is treated
// as a discount, not as tender, so it is shared across items[].amount the same
// way the whole-order `discount` is and the invoice declares what the customer
// actually paid. See retailOrder/redeemedAmount, which is where that position
// and the NT$1-per-point rate it depends on are written down.

const PER_POINT = 100

function earnPointsFor({ amount } = {}) {
  const paid = Number(amount)

  if (!Number.isFinite(paid) || paid <= 0) return 0

  return Math.floor(paid / PER_POINT)
}

export { earnPointsFor, PER_POINT }
